import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import FlightListTable from './Components/FlightListTable'

const FlightList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Flight List</HeadingOne>
                    <AddItemBtn url="add-flight" title="Create" />
                </>
            }>

            <div className="col-12">
                <FlightListTable />
            </div>
        </PageBody>
    )
}

export default FlightList